import * as React from 'react';
import * as classNames from 'classnames';
import {StatelessComponent} from 'react';
import {RUNNING, RUN_TESTS} from '../constants';

export interface ISessionEditorRunTestsProps {
  testsRunning: boolean;
  codeRunning: boolean;
  editorValue: string;
  disabled: boolean;

  onClick: (code: string) => void;
}

export const SessionEditorRunTests: StatelessComponent<ISessionEditorRunTestsProps> = ({
  testsRunning,
  codeRunning,
  editorValue,
  disabled,

  onClick,
}: ISessionEditorRunTestsProps) => {
  const buttonClassNames = classNames('btn btn_sm btn_left-blank', {
    'btn_genoa-viridian': !codeRunning,
    'btn_grey': codeRunning,
  });

  return (
    <button
      className={buttonClassNames}
      disabled={disabled}
      onClick={() => onClick(editorValue)}
    >
      <span className={classNames({'icon icon--run': !testsRunning, 'spinner': testsRunning})}/>
      <span className={'btn__label btn__label_left-blank'}>
        {testsRunning ? RUNNING : RUN_TESTS}
      </span>
    </button>
  );
};
